export default {
    name: "development",
    metaInfo: {
      title: 'Affordable Web Developer in Lexington KY | Canvas Development', 
      meta: [
          {                 
            name: 'keywords',
            content: 'team'
          },
          {
            name: 'description',
            content:'Canvas Development is Lexington, KY’s most diverse and affordable web development. High Quality, Fast Turnaround Time, Transparent Pricing. Guaranteed.'
          }
      ]
      
    },
    data() {
      return {
        specialize: [
          {
            icon: "https://ik.imagekit.io/canvasdev/web_application_U-0LjmOrh1.svg",
            title: "Web Application",
            text:
              "Web development is our core work. Whether you need a complex website or just a simple splash page, providing an online presence is our specialty.",
            route: { name: "webUx" }
          },
          {
            icon: "https://ik.imagekit.io/canvasdev/eCommerce_tTopOem8I.svg",
            title: "eCommerce",
            text:
              "If you need help choosing shopping carts and payment processors, looking to migrate to a new system, or merging data from an old database, we’ve got you covered.",
            route: { name: "shopify" }
          },
          {
            icon: "https://ik.imagekit.io/canvasdev/mobile_apps_z19VGRR27m.svg",
            title: "Mobile Apps",
            text:
              "Sometimes a mobile friendly website isn’t enough. If you need to take things to the next level by creating a dedicated mobile application, we can do that! ",
            route: { name: "mobileAppDevelopment" }
          }
        ]
      };
    }
  };
  
  